<template>
  <div :class="rootKls">
    <div
      role="tab"
      :aria-expanded="isActive"
      :aria-controls="scopedContentId"
      :aria-describedby="scopedContentId"
    >
      <div
        :id="scopedHeadId"
        :class="headKls"
        role="button"
        :tabindex="disabled ? -1 : 0"
        @click="handleHeaderClick"
        @keypress.space.enter.stop.prevent="handleEnterClick"
        @focus="handleFocus"
        @blur="focusing = false"
      >
        <slot name="title">{{ title }}</slot>
        <jd-icon :class="arrowKls">
          <arrow-right />
        </jd-icon>
      </div>
    </div>
    <jd-collapse-transition>
      <div
        v-show="isActive"
        :id="scopedContentId"
        :class="itemWrapperKls"
        role="tabpanel"
        :aria-hidden="!isActive"
        :aria-labelledby="scopedHeadId"
      >
        <div :class="itemContentKls">
          <slot />
        </div>
      </div>
    </jd-collapse-transition>
  </div>
</template>

<script lang="ts" setup>
import JdCollapseTransition from '@jdesign-vue/components/collapse-transition'
import JdIcon from '@jdesign-vue/components/icon'
import { AngleRight as ArrowRight } from '@jd/jdesign-icons-vue'
import { collapseItemProps } from './collapse-item'
import { useCollapseItem, useCollapseItemDOM } from './use-collapse-item'

defineOptions({
  name: 'JdCollapseItem',
})

const props = defineProps(collapseItemProps)
const {
  focusing,
  id,
  isActive,
  handleFocus,
  handleHeaderClick,
  handleEnterClick,
} = useCollapseItem(props)

const {
  arrowKls,
  headKls,
  rootKls,
  itemWrapperKls,
  itemContentKls,
  scopedContentId,
  scopedHeadId,
} = useCollapseItemDOM(props, { focusing, isActive, id })

defineExpose({
  /** @description current collapse-item whether active */
  isActive,
})
</script>
